export const transformCase = {
  SnakeCase: 'SNAKE_CASE',
  CamelCase: 'CAMEL_CASE'
};

// Used for react-country-flag
export const countryCodes = {
  en: 'en',
  ca: 'ca',
  gb: 'gb'
};

export const inputTypes = {
  tel: 'tel',
  submit: 'submit',
  search: 'search',
  number: 'number',
  text: 'text',
  password: 'password',
  email: 'email',
  date: 'date'
};

export const sessionStatusText = {
  sessionActive: 'session active',
  sessionExpire: 'session expired',
  sessionTimeout: 'Session timed out, please sign in again.'
};

export const termsConditions = {
  tosElementId: 'tos',
  shortTerms: 'short'
};
